import { find } from "lodash";

import { getWebsiteHeaderData } from "app/components/dashboard/widget-wizard/utils/dashboardWizardUtils";
import { fetchWithFullResponseInterceptorHandlers } from "app/components/widget/widget-fetchers/DefaultDataFetcher";
import { GraphWidget } from "app/components/widget/widget-types/GraphWidget";
import { translate } from "app/filters/i18nFilter";
import { ENDPOINT_PREFIX_WITH_CATEGORY_SUPPORT } from "app/pages/website-analysis/TrafficAndEngagement/UtilityFunctionsAndConstants/UtilityFunctions";
import { DefaultFetchService } from "app/services/fetchService";

import { UNBOUNCED_VISITS } from "../widget-filters/components/consts";
import { EngagedVisitsSupportGraphWidgetFilters } from "../widget-filters/EngagedVisitsSupportGraphWidgetFilters";

export const METADATA_TYPE = "EngagedVisitsSupportGraph";
const DEFAULT_NAVIGATION_STATE = "digitalsuite_website_trafficandengagement";
const mapMetricToUrlParamValue = {
    EngagementVisits: "Visits",
    EngagementAvgVisitDuration: "AvgVisitDuration",
    EngagementPagesPerVisit: "PagesPerVisit",
    EngagementTotalPagesViews: "PageViews",
};
const mapMetricToApiMetric = {
    EngagementVisits: "Visits",
    EngagementAvgVisitDuration: "Duration",
    EngagementPagesPerVisit: "PagesPerVisit",
    EngagementTotalPagesViews: "PageViews",
};

export class EngagedVisitsSupportGraphWidget extends GraphWidget {
    static getWidgetDashboardType() {
        return "Graph";
    }

    static getWidgetResourceType() {
        return "Graph";
    }

    static getWidgetMetadataType() {
        return METADATA_TYPE;
    }

    private dataFetcherFactory = () => {
        return {
            create: (widget) => {
                return {
                    fetch: async () => {
                        const apiParams = { ...widget.apiParams };
                        try {
                            const res = await getWebsiteHeaderData([{ name: widget.apiParams.keys }]);
                            const showGaData = !!find(res, { hasGaToken: true });
                            if (!showGaData) {
                                delete apiParams.ShouldGetVerifiedData;
                            }
                        } catch (e) {
                            delete apiParams.ShouldGetVerifiedData;
                        }

                        const fetchService = DefaultFetchService.getInstance();
                        return fetchService
                            .get(
                                `${ENDPOINT_PREFIX_WITH_CATEGORY_SUPPORT}/${
                                    mapMetricToApiMetric[widget._params.metric]
                                }/Graph`,
                                apiParams,
                            )
                            .then(...fetchWithFullResponseInterceptorHandlers)
                            .then((rawData) => rawData);
                    },
                };
            },
        };
    };

    public getFetcherFactory() {
        return this.dataFetcherFactory();
    }

    static getFiltersComponent() {
        return EngagedVisitsSupportGraphWidgetFilters;
    }

    public getProUrl(rowParams?) {
        const urlParams = Object.assign(this._getProUrlParams(), {
            unBounced: this.apiParams.unBounced,
            selectedWidgetTab: mapMetricToUrlParamValue[this._widgetModel.metric],
        });

        return this._swNavigator.href(DEFAULT_NAVIGATION_STATE, urlParams, {});
    }

    getViewData() {
        super.getViewData();
        if (String(this.apiParams.unBounced).toLowerCase() === "true") {
            this.viewData.subtitleTextItem = {
                text: translate(`home.dashboards.wizard.filters.${UNBOUNCED_VISITS}`),
            };
        }
        return this.viewData;
    }
}

EngagedVisitsSupportGraphWidget.register();
